// src/components/sections/home/FeaturedProducts.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ProductCard from '../../ui/ProductCard';
import { getFeaturedProducts } from '../../../data/products';

const FeaturedProducts: React.FC = () => {
  const featuredProducts = getFeaturedProducts();
  
  // Update product image paths
  const updatedProducts = featuredProducts.map(product => {
    let updatedImage = product.image;
    
    // Map old image paths to new image paths
    if (product.id === 'traditional-oil') {
      updatedImage = '/assets/images/domov/izdelki/tradicionalno-bucno-olje-image.png';
    } else if (product.id === 'premium-oil') {
      updatedImage = '/assets/images/domov/izdelki/premium-bucno-olje-image.png';
    } else if (product.id === 'gift-set') {
      updatedImage = '/assets/images/domov/izdelki/darilni-set-image.png';
    }
    
    return {
      ...product,
      image: updatedImage
    };
  });
  
  return (
    <section className="bg-neutral py-16 md:py-24">
      <div className="container-wide">
        <div className="section-title">
          <h2>Naši izbrani izdelki</h2>
          <div className="divider"></div>
          <p>
            Spoznajte našo izbrano kolekcijo izdelkov, ki predstavljajo več kot stoletje 
            tradicije in znanja v pridelavi bučnega olja.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {updatedProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <Link 
            to="/izdelki" 
            className="btn-primary inline-flex items-center"
          >
            Vsi izdelki
            <ArrowRight size={18} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;